import { Injectable } from '@angular/core';
import { AppAmplifyConfig } from '@core/models/amplifyConfig';
import { NamespaceView } from '@core/models/namespaceView.interface';
import { Amplify } from "aws-amplify";

@Injectable({
  providedIn: 'root'
})
export class AwsconfigService {
  loginPasswordAwsConfig = {};
  googleAwsConfig = {};
  appleAwsConfig = {};

  createAmplifyConfig(userPoolId: string, oauthClientId: string): AppAmplifyConfig  {
    const cognitoPool = { userPoolId, oauthClientId };
    localStorage.setItem('cognitoPool', JSON.stringify(cognitoPool));
  
    return {
      Auth: {
        region: 'us-east-1',
        mandatorySignIn: false,
        userPoolId: userPoolId,
        userPoolWebClientId: oauthClientId,
        authenticationFlowType: 'USER_PASSWORD_AUTH',
      },
    }
  }

  configureAws({userPoolId, oauthClientId, oauthClientIdGoogle, oauthClientIdApple}: NamespaceView): void {
    const config = this.createAmplifyConfig(userPoolId, oauthClientId);
    this.loginPasswordAwsConfig = {
      ...config,
      oauth: {
        domain: 'theneuron-dooh.auth.us-east-1.amazoncognito.com',
        redirectSignIn: ['https://theneuron-dooh.auth.us-east-1.amazoncognito.com/', 'https://smb.staging.theneuron.com/', 'http://localhost:4200'],
        urlOpener: (url: string) => {
          const left = (window.screen.width - 600 ) / 2;
          const top = (window.screen.height - 549 ) / 2;
          const windowProxy = window.open( url, "center window",
            `resizable = yes, width=600,height=549,top=${top},left=${left}`);
          return Promise.resolve(windowProxy)
      }
      }
    }

    const configGoogle = this.createAmplifyConfig(userPoolId, oauthClientIdGoogle);
    this.googleAwsConfig = {
      ...configGoogle,
      oauth: {
        domain: 'theneuron-dooh.auth.us-east-1.amazoncognito.com',
        redirectSignIn: ['https://dooh-api.staging.theneuron.com/admin/social/google'],
        clientID: oauthClientIdGoogle,
        responseType: 'code',
        storage: localStorage
      }
    }

    const configApple = this.createAmplifyConfig(userPoolId, oauthClientIdApple);
    this.appleAwsConfig = {
      ...configApple,
      oauth: {
        domain: 'theneuron-dooh.auth.us-east-1.amazoncognito.com',
        redirectSignIn: ['http://localhost:4200/dashboard'],
        urlOpener: (url: string) => {
          const left = (window.screen.width - 600 ) / 2;
          const top = (window.screen.height - 549 ) / 2;
          const windowProxy = window.open( url, "center window",
            `resizable = yes, width=600,height=549,top=${top},left=${left}`);
          return Promise.resolve(windowProxy)
        }
      }
    }

    const clientid = localStorage.getItem("clientid");
    if (clientid === 'google') {
      Amplify.configure(this.googleAwsConfig);
    } else {
      Amplify.configure(this.loginPasswordAwsConfig);
    }
  }

  applyConfigLoginPassword(): void {
    Amplify.configure(this.loginPasswordAwsConfig);
  }

  applyConfigGoogle(): void {
    Amplify.configure(this.googleAwsConfig);
  }

  applyConfigApple(): void {
    Amplify.configure(this.appleAwsConfig);
  }

  reconfigureAuth(userPoolId: string, oauthClientId: string): void {
    const config = this.createAmplifyConfig(userPoolId, oauthClientId);
    Amplify.configure(config);
  }

}
